import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeQuantityCommand extends BaseCommand {
  CommandName = "ChangeQuantity";
  Command: {
    Quantity: number;
    BookingItemTmpId: string;
  };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string, value: number) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId, Quantity: value };
  }
}
